export default "__VITE_ASSET__BiZ6L5YQ__"